/**
 * ClinicalHUD3 workspace mode config.
 * Teaching holds no PHI. Live is the clinical-use mode.
 * HUD2 constants stay unchanged — do not import them here.
 */
import {
  CLINICAL_HUD3_LIVE_COLLECTION,
  CLINICAL_HUD3_TEACHING_COLLECTION,
} from "./clinicalHud3Constants";

/**
 * Even G2 is off in v1.
 * See the "Even G2 reactivation note" in CLINICALHUD3_BUILD_DECISIONS.md.
 * A later plugin must target clinicalHud3Live only, never Teaching.
 */
export const CLINICAL_HUD3_EVEN_G2_ENABLED = false;

export const CLINICAL_HUD3_TEACHING = Object.freeze({
  kind: "teaching",
  collection: CLINICAL_HUD3_TEACHING_COLLECTION,
  allowPhi: false,
  requiresCaseId: true,
  transcriptSource: "case",
  allowMicListen: false,
  allowGemini35: false,
  allowShareImport: false,
  allowSendDischarge: false,
  allowExpertAdvice: false,
  allowClarifyingQuestions: true,
  allowEvenG2: CLINICAL_HUD3_EVEN_G2_ENABLED,
  generation: "onDemand",
  bannerText: "Teaching — simulated case. Do not enter real patient information.",
  startUsageEvent: "teaching_session_started",
});

export const CLINICAL_HUD3_LIVE = Object.freeze({
  kind: "live",
  collection: CLINICAL_HUD3_LIVE_COLLECTION,
  allowPhi: true,
  requiresCaseId: false,
  transcriptSource: "user",
  allowMicListen: true,
  allowGemini35: true,
  allowShareImport: true,
  allowSendDischarge: true,
  allowExpertAdvice: true,
  allowClarifyingQuestions: true,
  allowEvenG2: CLINICAL_HUD3_EVEN_G2_ENABLED,
  generation: "interval",
  bannerText: "Live — clinical use. Real patient information.",
  startUsageEvent: "live_session_started",
});

/**
 * @param {'teaching'|'live'} kind
 */
export function getClinicalHud3Config(kind) {
  if (kind === CLINICAL_HUD3_TEACHING.kind) return CLINICAL_HUD3_TEACHING;
  if (kind === CLINICAL_HUD3_LIVE.kind) return CLINICAL_HUD3_LIVE;
  throw new Error(`Unknown ClinicalHUD3 workspace kind: ${kind}`);
}
